import PrintSetItemService from '@/services/bytepro/printSetItem.service';

export const printSetItem = {
  namespaced: true,
  state: {
    printSetItems: null,
    loading: false,
    error: null,
  },
  getters: {
    getPrintSetItems: (state) => state.printSetItems,
    isLoading: (state) => state.loading,
    hasError: (state) => state.error !== null,
    getError: (state) => state.error,
  },
  actions: {
    async get({ commit, state }) {
      // Return cached data if available
      if (state.printSetItems) {
        return Promise.resolve({ data: state.printSetItems, status: 200 });
      }

      commit('setLoading', true);
      commit('clearError');

      try {
        const resp = await PrintSetItemService.get();
        commit('setPrintSetItems', resp.data);
        commit('setLoading', false);
        commit('dummy', 'get - success');
        return Promise.resolve(resp);
      } catch (error) {
        commit('setError', error.response);
        commit('setLoading', false);
        commit('dummy', 'get - error');
        return Promise.reject(error.response);
      }
    },
    clearCache({ commit }) {
      commit('clearPrintSetItems');
    },
  },
  mutations: {
    setPrintSetItems(state, data) {
      state.printSetItems = data;
    },
    clearPrintSetItems(state) {
      state.printSetItems = null;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setError(state, error) {
      state.error = error;
    },
    clearError(state) {
      state.error = null;
    },
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
